const useSettingsStyles = () => {
    return {
        tabListStyles: {
            display: 'flex',
            gap: 1.5
        }
    };
};
export default useSettingsStyles;
